<!-- 下载 -->
<template>
  <div>
    <template v-if="showDownloadType === 'drawer'">
      <el-drawer
        :modelValue="showDownload"
        title="导出数据"
        :size="200"
        @close="handleClose"
      >
        <el-radio-group v-model="radio">
          <el-radio :value="1">选中数据</el-radio>
          <el-radio :value="2">当前页数据</el-radio>
          <el-radio :value="3" v-show="exportDataUrl !== ''">全部</el-radio>
        </el-radio-group>
        <div class="dialog-footer">
          <el-button type="primary" @click="handleConfirm">导 出</el-button>
          <el-button @click="handleClose">取 消</el-button>
        </div>
      </el-drawer>
    </template>
    <template v-else-if="showDownloadType === 'dialog'">
      <Dialog
        :modelValue="showDownload"
        title="导出数据"
        confirmText="导 出"
        @onConfirm="handleConfirm"
        @onClosed="handleClose"
      >
        <template #content>
          <el-radio-group v-model="radio">
            <el-radio :value="1">选中数据</el-radio>
            <el-radio :value="2">当前页数据</el-radio>
            <el-radio :value="3" v-show="exportDataUrl !== ''">全部</el-radio>
          </el-radio-group>
        </template>
      </Dialog>
    </template>
  </div>
</template>

<script setup>
import { ref } from "vue";
import Dialog from "@/components/Element/Dialog";

const props = defineProps({
  /* 是否显示下载 */
  showDownload: {
    type: Boolean,
    default: false,
  },
  /* 显示下载组件的类型（drawer抽屉、dialog 对话框） */
  showDownloadType: {
    type: String,
    default: "drawer",
  },
  /** 导出全部数据的url */
  exportDataUrl: {
    type: String,
    default: "",
  },
});

const emits = defineEmits(["update:showDownload", "onExportData"]);
const radio = ref("");

const handleClose = () => {
  emits("update:showDownload", false);
};
/** 导出数据 */
const handleConfirm = () => {
  emits("onExportData", radio.value);
};
</script>

<style lang="scss" scoped></style>
